/**
 * OrganizationManagement-new.tsx
 * New-page entry point for Organization Management redesign.
 * This wrapper reuses the existing OrganizationManagement logic until Figma-specific UI is applied.
 */

import React from 'react';
import OrganizationManagementPage from './OrganizationManagement';

/**
 * OrganizationManagementNew
 * Named page component for the new Organization Management route.
 */
function OrganizationManagementNew(): React.ReactElement
{
    return <OrganizationManagementPage />;
}

export default OrganizationManagementNew;
